import { useId, useRef } from "react";
import Icon from "../Icon";
import useFocoModal from "../../hooks/useFocoModal";

// Ventana de las acciones de «Tareas» (mandar, «No puedo», hilo): foco dentro, Tab atrapado y
// Escape cierra. En escritorio flota centrada; en movil es una hoja inferior (CSS .mt-dlg).
export default function Dialogo({ titulo, onCerrar, children, ancho = 460 }) {
  const ref = useRef(null);
  const tituloId = useId();
  useFocoModal(ref, true, onCerrar);
  return (
    <div className="mt-dlg-fondo" onClick={onCerrar}>
      <div ref={ref} role="dialog" aria-modal="true" aria-labelledby={tituloId} className="mt-dlg" style={{ maxWidth: ancho }}
        onClick={e => e.stopPropagation()}>
        <div className="mt-dlg-cab">
          <h3 id={tituloId}>{titulo}</h3>
          <button type="button" className="mt-x btn" aria-label="Cerrar" onClick={onCerrar}>
            <Icon name="x" size={14} color="currentColor" />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
